// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\CommonService.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { DeployRecord } from './DeployRecord';
import { get, post, put, del } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Request';
import { RequestResult } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/RequestResult';
import { Condition } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Condition';
/**
 * 部署记录 通用服务类
 * 部署记录
 */
export class DeployRecordService {
  /**
   * 实体 部署记录 的通用CRUD服务
   * @deployRecord 要创建的实体：部署记录
   * @return 返回：创建的实体
   */
  static async CreateAsync(deployRecord: DeployRecord): Promise<DeployRecord | null> {
    return new Promise((resolve, reject) => {
      post('metapattern-ide-mda/api/deployrecord/create', deployRecord.toJson())
        .then((response: any) => {
          if (response) {
            const result = DeployRecord.Create(response);
            resolve(result);
          } else {
            resolve(null);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 部署记录 的通用CRUD服务：根据ID加载实体
   * @param id 要查询的实体id
   * @return 返回：实体DTO
   */
  static async LoadByIdAsync(id: string): Promise<DeployRecord | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/api/deployrecord/loadbyid', { id: id })
        .then((response: any) => {
          if (response) {
            const result = DeployRecord.Create(response);
            resolve(result);
          } else {
            resolve(null);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 部署记录 的通用CRUD服务：根据ID加载实体
   * @param ids 要查询的实体id列表
   * @return 返回：实体DTO列表
   */
  static async LoadByIdsAsync(ids: Array<string>): Promise<Array<DeployRecord>> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/api/deployrecord/loadbyids', { ids: ids.join(',') })
        .then((response: any) => {
          const result = new Array<DeployRecord>();
          if (response) {
            response.forEach((item: DeployRecord) => {
              result.push(DeployRecord.Create(item));
            });
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 部署记录 的通用CRUD服务：获取所有有效的实体
   * @return 返回：实体DTO列表
   */
  static async LoadAllAsync(): Promise<Array<DeployRecord>> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/api/deployrecord/loadall')
        .then((response: any) => {
          const result = new Array<DeployRecord>();
          if (response) {
            response.forEach((item: DeployRecord) => {
              result.push(DeployRecord.Create(item));
            });
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 部署记录 的通用CRUD服务：更新实体
   * @deployRecord 要更新的实体：部署记录
   * @return 返回：更新后的实体
   */
  static async UpdateAsync(deployRecord: DeployRecord): Promise<DeployRecord | null> {
    return new Promise((resolve, reject) => {
      put('metapattern-ide-mda/api/deployrecord/update', deployRecord.toJson())
        .then((response: any) => {
          if (response) {
            const result = DeployRecord.Create(response);
            resolve(result);
          } else {
            resolve(null);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 部署记录 的通用CRUD服务 ：根据id逻辑删除实体
   * @param id 要删除的实体id
   * @return 返回：是否成功执行
   */
  static async DeleteAsync(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      del('metapattern-ide-mda/api/deployrecord/deletebyid', { id: id })
        .then((response: any) => {
          if (response) {
            const result = response as boolean;
            resolve(result);
          } else {
            resolve(false);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 部署记录 的通用CRUD服务 ：根据id列表逻辑删除实体
   * @param ids 要删除的实体id列表
   * @return 返回：成功删除的条数
   */
  static async DeleteBatchAsync(ids: Array<string>): Promise<number> {
    return new Promise((resolve, reject) => {
      del('metapattern-ide-mda/api/deployrecord/deletebyids', { ids: ids.join(',') })
        .then((response: any) => {
          if (response) {
            const result = response as number;
            resolve(result);
          } else {
            resolve(0);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }
}
